import { Flex } from '@grupoboticario/flora-react';
import { CheckCircleIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';
import { getLongDate, getShortCycle } from 'helpers';
import { useResellerDetail } from 'hooks';
import { useLoyaltyIncentiveCampaign } from 'pages/IncentiveCampaign/hooks';

import Styles from './Confirm.styles';

export const Confirm = () => {
  const { data: incentiveCampaign, optInData } = useLoyaltyIncentiveCampaign();
  const { data: resellerDetail } = useResellerDetail();
  const isLoyaltyMember = resellerDetail?.reseller.isLoyaltyMember ?? false;

  const formattedComplianceDate = incentiveCampaign?.complianceDate
    ? getLongDate(incentiveCampaign.complianceDate)
    : '';

  const cycleNumber = optInData?.campaign?.cycle
    ? parseInt(getShortCycle(optInData.campaign.cycle)).toString()
    : '';

  return (
    <Styles.InfoCard>
      <Flex gap='$2'>
        <CheckCircleIcon size={32} />

        <Flex gap='$2' direction='column'>
          <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold'>
            Você está participando da campanha!
          </ResponsiveFloraTypography>
          {isLoyaltyMember ? (
            <ResponsiveFloraTypography
              fontSize='bodyLargeStandard'
              color='$nonInteractivePredominant'
            >
              Estamos considerando todos os seus pedidos elegíveis desde a sua inscrição no ciclo{' '}
              {cycleNumber}! É preciso estar adimplente até {formattedComplianceDate} para ser
              elegível a premiação.
            </ResponsiveFloraTypography>
          ) : (
            <ResponsiveFloraTypography
              fontSize='bodyLargeStandard'
              color='$nonInteractivePredominant'
            >
              Estamos considerando todos os seus pedidos elegíveis desde a sua inscrição no ciclo{' '}
              {cycleNumber}! É preciso estar adimplente até {formattedComplianceDate} para ser
              elegível a premiação, e alcançar pelo menos o primeiro desafio do incentivo para
              resgate de ponto.
            </ResponsiveFloraTypography>
          )}
        </Flex>
      </Flex>
    </Styles.InfoCard>
  );
};
